export default "__VITE_ASSET__C511FVLH__"